<template>
  <div>
    <div class="lp-edit-modal">
      <div class="lp-edit-title-text">Tambah Pertanyaan</div>
      <div class="lp-edit-form">
        <div class="lp-edit-half-input-wrapper">
          <div class="lp-edit-hiw-label">ID</div>
          <div class="lp-edit-hiw-full">
            <input type="text" class="lp-edit-hiw-text" :placeholder="`${formName(step_id)}`" disabled />
          </div>
        </div>
        <div class="lp-edit-half-input-wrapper">
          <div class="lp-edit-hiw-label">Tipe</div>
          <div class="lp-edit-hiw-multiple">
            <select class="lp-edit-hiw-select-full" v-model="question_type">
              <option value="default" disabled selected>Default</option>
              <option value="text">Text</option>
              <option value="textarea">Multiple Line Text</option>
              <option value="radio">Yes / No</option>
              <option value="date-picker">Date Picker</option>
              <option value="date-range">Date Start & Date End</option>
              <option value="attachment">Attachment</option>
            </select>
          </div>
        </div>
        <div class="lp-edit-half-input-wrapper">
          <div class="lp-edit-hiw-label">Mandatory</div>
          <div class="lp-edit-hiw-full">
            <input type="checkbox" class="lp-edit-hiw-checkbox" v-model="is_mandatory" />
          </div>
        </div>
        <div class="lp-edit-half-input-wrapper">
          <div class="lp-edit-hiw-label">Teks</div>
          <div class="lp-edit-hiw-full">
            <textarea name="" id="" cols="30" rows="10" class="lp-edit-hiw-text" v-model="text"></textarea>
          </div>
        </div>
        <div class="lp-edit-half-input-wrapper">
          <div class="lp-edit-hiw-label">Status</div>
          <div class="lp-edit-hiw-multiple">
            <select class="lp-edit-hiw-select" v-model="is_active">
              <option value="true">Active</option>
              <option value="false">Inactive</option>
            </select>
          </div>
        </div>
        <p class="text-sm text-center">* Tipe Pertanyaan default/bawaan hanya dapat mengubah teks, mandatory dan status
        </p>
      </div>
      <div class="lp-button-container">
        <div class="lp-button-wrapper">
          <div class="lp-cancel-button" @click="closeModal">Cancel</div>
          <div class="lp-save-button" @click="addForm">Save</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      question_type: 'text',
      is_mandatory: false,
      text: '',
      is_active: 'true'
    }
  },
  computed: {
    total_data() {
      return this.$store.state.mdLandingStore.total_data
    },
    step_id() {
      return this.$store.state.mdLandingStore.step_id
    },
    bidang_usaha_id() {
      return this.$store.state.mdLandingStore.bidang_usaha_id
    },
    type_pendaftaran_id() {
      return this.$store.state.mdLandingStore.type_pendaftaran_id
    }
  },
  methods: {
    formName(value) {
      const list = ['Registrasi', 'Profile', 'Alamat', 'Bank', 'Afiliation', 'Legal Document', 'Finish']

      return `${list[Number(value) - 1]}-${Number(this.total_data) + 1}`

    },
    closeModal() {
      this.$emit('closeModal')
    },
    async addForm() {
      await this.$store.dispatch('mdLandingStore/addForm', {
        name: `${this.formName(this.step_id)}`,
        question_type: this.question_type,
        is_mandatory: this.is_mandatory,
        text: this.text,
        is_active: this.is_active,
        bidang_usaha_id: this.bidang_usaha_id,
        type_pendaftaran_id: this.type_pendaftaran_id,
        md_landing_step_id: this.step_id
      })
      this.closeModal()
    }
  }
}
</script>